import { useCallback, useMemo, useState } from "react";
import { ISearchContext } from "../SearchContext";
import { ISearchStateProps } from "../HeaderSearch/HeaderSearch";

export const useSearchState = ({
  onSearch,
  onSearchNavigate,
}: ISearchStateProps): ISearchContext => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");

  const handleInputChange = useCallback(
    (value: string) => {
      setSearchTerm(value);
      onSearch?.(searchTerm);
    },
    [onSearch, searchTerm],
  );

  const clearSearch = useCallback(() => setSearchTerm(""), []);

  const closeSearch = useCallback(() => {
    setIsActive(false);
    clearSearch();
  }, [clearSearch]);

  const setActiveSearch = useCallback(() => setIsActive(true), []);

  const handleListItemClick = useCallback(
    (id: string) => {
      onSearchNavigate?.(id);
      setSelectedItem(id);
      closeSearch();
    },
    [setSelectedItem, onSearchNavigate, closeSearch],
  );

  const useSearchContext = useMemo(() => {
    return {
      isActive,
      searchTerm,
      selectedItem,
      clearSearch,
      handleInputChange,
      setActiveSearch,
      closeSearch,
      handleListItemClick,
    };
  }, [
    clearSearch,
    closeSearch,
    handleInputChange,
    selectedItem,
    isActive,
    searchTerm,
    setActiveSearch,
    handleListItemClick,
  ]);

  return useSearchContext;
};
